<template>
  <div>
    <div
      v-if="!location"
      class="base-info-container"
    >
      <div style="position: relative">
        <div class="line" />
      </div>
      <div style="padding: 16px 0;">
        <van-row>
          <van-col span="14">
            <van-col class="label">
              姓<div class="space" />名：
            </van-col>
            <van-col>
              {{ baseInfo.name }}
            </van-col>
          </van-col>
          <van-col span="10">
            <van-col class="label">
              性<div class="space" />别：
            </van-col>
            <van-col>
              {{ baseInfo.sex }}
            </van-col>
          </van-col>
        </van-row>
        <van-row class="middle-row">
          <van-col span="14">
            <van-col class="label">
              年<div class="space" />龄：
            </van-col>
            <van-col>
              {{ baseInfo.age }}
            </van-col>
          </van-col>
          <van-col span="10">
            <van-col class="label">
              日<div class="space" />期：
            </van-col>
            <van-col>
              {{ baseInfo.date }}
            </van-col>
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24">
            <van-col class="label">
              编<div class="space" />号：
            </van-col>
            <van-col>
              {{ baseInfo.patientId }}
            </van-col>
          </van-col>
        </van-row>
      </div>
      <div style="position: relative">
        <div class="line" />
      </div>
    </div>
    <div
      v-else
      class="base-info-container"
    >
      <div style="position: relative">
        <div class="line" />
      </div>
      <div style="padding: 16px 0;">
        <van-row>
          <van-col span="8">
            <van-col class="label">
              姓<div class="space" />名：
            </van-col>
            <van-col>
              {{ baseInfo.name }}
            </van-col>
          </van-col>
          <van-col span="8">
            <van-col class="label">
              性<div class="space" />别：
            </van-col>
            <van-col>
              {{ baseInfo.sex }}
            </van-col>
          </van-col>
          <van-col span="8">
            <van-col class="label">
              年<div class="space" />龄：
            </van-col>
            <van-col>
              {{ baseInfo.age }}
            </van-col>
          </van-col>
        </van-row>
        <van-row style="margin-top: 25px;">
          <van-col span="24">
            <van-col class="label">
              编<div class="space" />号：
            </van-col>
            <van-col>
              {{ baseInfo.patientId }}
            </van-col>
          </van-col>
        </van-row>
      </div>
      <div style="position: relative">
        <div class="line" />
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col } from 'vant'

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {
          name: '',
          sex: '',
          age: '',
          patientId: ''
        }
      }
    },
    location: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}

</script>

<style lang="less" scoped>
.base-info-container{
  padding: 0 .3rem;
  font-size: .28rem;
  .line {
    &::after {
      content: "";
      display: block;
      position: absolute;
      bottom: 1px;
      left: 0;
      width: 100%;
      height: 1px;
      background: linear-gradient(to right, #d5d5d5, #d5d5d5 13px, transparent 10px, transparent);
      background-size: 15px 100%;
    }
  }
  .space {
    display: inline-block;
    width: 0.28rem;
  }
  .half-space {
    display: inline-block;
    width: 0.14rem;
  }
  .label {
    color: #999999;
  }
  .middle-row {
    margin: 20px 0;
  }
}

</style>
